<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <p class="s_c999 m-b-15">确认退款后，款项将返回买家支付账户，请务必确认退款金额，订单中涉及到的金币或积分，确认退款后由系统退还给买家</p>
      <p class="s_c333 p-l-15 m-b-24">处理方式：{{form.refund_type==1?"仅退款":"退货退款"}}</p>
      <p class="s_c333 p-l-15 m-b-24">支付金额：<span class="s_cd41">￥{{refundsData.pay_price}}</span></p>
      <p class="s_c333 p-l-15 m-b-24" v-if='type=="more"'>申请金额：<span class="s_cd41">￥{{refundsData.refund_money}}</span></p>

      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <!-- 快递并已发货 -->
        <div v-if="is_refund">
          <!-- 退款类型 logistic_type已发货 delivery_type快递-->
          <a-form-item ref="refund_type" label="退款类型" name="refund_type"  v-if="refundsData.delivery_type==1&&refundsData.logistic_type==1">
            <a-radio-group v-model:value="form.refund_type">
              <a-radio :value="1">退款</a-radio>
              <a-radio :value="3">退货退款</a-radio>
            </a-radio-group>
          </a-form-item>
        </div>
        <!-- 是否同意 -->
        <a-form-item ref="is_agree" label="是否同意" name="is_agree" v-if='type=="more"'>
          <a-radio-group v-model:value="form.is_agree">
            <a-radio :value="1">同意</a-radio>
            <a-radio :value="2">拒绝</a-radio>
          </a-radio-group>
        </a-form-item>
        <!-- <a-form-item ref="refund_amt" label="退款金额" name="refund_amt" v-if='form.is_agree == 1' >
          <a-input v-model:value="form.refund_amt" placeholder='请输入退款金额' />
        </a-form-item> -->
        <a-form-item ref="refuse_desc" label="拒绝理由" name="refuse_desc" v-if='form.is_agree == 2'>
          <a-input v-model:value="form.refuse_desc" placeholder='请输入拒绝理由' />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit" :loading='loading'>
            确定
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, watchEffect, reactive, toRefs, inject } from 'vue';
import { orderRefundRefund, orderNoRefund } from '@/api/order';
import { message } from 'ant-design-vue';
import { iscode } from '@/utils/app';
// 初始化默认筛选项数值
let defForm = {
  // refund_amt: '',
  is_agree: 1,
  refuse_desc: '',
  refund_type: 1, //退款类型，
};
export default {
  name: 'refundsForem',
  components: {},
  props: {
    refundsData: {
      type: Object,
    },
    type: {
      type: String,
    },
    is_refund: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      refundsData: {},
      cityList: [],
      address: [],
      loading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      rules: {
        price: [{ required: true, message: '请输入退款金额' }],
      },
    });
    const ruleForm = ref();
    const _lodash = inject('_lodash');
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          state.loading = true;
          let res;
          if (props.type == 'more') {
            res = await orderRefundRefund({
              ...form.value,
              order_no: state.refundsData.order_no,
              again: state.refundsData.status ? 1 : 0,
            })
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            res = await orderNoRefund({
              refund_amt: form.value.refund_amt,
              order_no: state.refundsData.order_no,
            })
              .then((res) => res.data)
              .catch((error) => error);
          }

          if (iscode(res)) {
            emit('submitrefunds');
            message.success(res.msg);
          } else {
            message.error(res.msg);
          }
          state.loading = false;
        })
        .catch((error) => {
          message.error('请完善表单！');
        });
    };
    watchEffect(() => {
      var refundsData = props.refundsData || {};
      if (!_lodash.isEmpty(refundsData)) {
        state.refundsData = refundsData;
      }
    });
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
    };
  },
};
</script>